import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    http = inject(HttpClient);

    async changePassword(userId: number, password: string) {
        return await firstValueFrom(this.http.post<{ success: boolean; message: string }>(`${environment.serviceName}/users/change-password`, { userId, password }));
    }
}
